import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../services/core/auth.service';
import { HelperAuthService } from '../services/core/helper-auth.service';

import { APP_BASE_URL } from '../common/constants';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public readonly loginForm: UntypedFormGroup;

  public appPreference: string;
  public errorMessage: string;
  public authenticating: boolean = false;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly helperAuth: HelperAuthService
  ) {
    this.loginForm = this.fb.group({
      email: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }

  ngOnInit() {
    if (this.auth.loggedIn()) {
      this.router.navigate([APP_BASE_URL]);
    }
  }

  login(): void {
    this.authenticating = true;
    this.errorMessage = '';

    this.helperAuth
      .login(this.loginForm.value)
      .then(({ data, msg, err }) => {
        this.authenticating = false;

        if (err) {
          this.authenticating = false;
          this.errorMessage = msg || 'Invalid email or password';
        }

        if (data) {
          const payload = this.auth.parseTokenAndSetState(data.jwt);

          if (payload.staffFlag) {
            this.router.navigate([APP_BASE_URL, 'staff', 'dashboard']);
          } else {
            this.router.navigate([APP_BASE_URL, 'license']);
          }
        }
      })
      .catch((err) => {
        this.authenticating = false;
        this.errorMessage = err.msg || 'Invalid email or password';
      });
  }
}
